export const GamePhase = {
  SETUP: "SETUP",
  MULLIGAN: "MULLIGAN",
  START_TURN: "START_TURN",
  MAIN_PHASE: "MAIN_PHASE",
  END_TURN: "END_TURN",
  GAME_OVER: "GAME_OVER",
};

export const PlayerId = {
  PLAYER1: "PLAYER1",
  PLAYER2: "PLAYER2",
};

// プレイヤー役割の固定化
export const HUMAN_PLAYER_ID = PlayerId.PLAYER1;
export const NPC_PLAYER_ID = PlayerId.PLAYER2;

export const CardType = {
  WEALTH: 1,
  EVENT: 2,
  IDEOLOGY: 3,
};

export const TriggerType = {
  // Card Movement Triggers
  CARD_DRAWN: "CARD_DRAWN",
  CARD_DRAWN_THIS: "CARD_DRAWN_THIS",
  CARD_DRAWN_OWNER: "CARD_DRAWN_OWNER",
  CARD_DRAWN_OPPONENT: "CARD_DRAWN_OPPONENT",
  CARD_PLACED: "CARD_PLACED",
  CARD_PLACED_THIS: "CARD_PLACED_THIS",
  CARD_PLACED_OWNER: "CARD_PLACED_OWNER",
  CARD_PLACED_OPPONENT: "CARD_PLACED_OPPONENT",
  CARD_DISCARDED: "CARD_DISCARDED",
  CARD_DISCARDED_THIS: "CARD_DISCARDED_THIS",
  CARD_DISCARDED_OWNER: "CARD_DISCARDED_OWNER",
  CARD_DISCARDED_OPPONENT: "CARD_DISCARDED_OPPONENT",
  CARD_BOUNCED: "CARD_BOUNCED",
  CARD_BOUNCED_THIS: "CARD_BOUNCED_THIS",
  CARD_BOUNCED_OWNER: "CARD_BOUNCED_OWNER",
  CARD_BOUNCED_OPPONENT: "CARD_BOUNCED_OPPONENT",
  CARD_ADDED_TO_HAND: "CARD_ADDED_TO_HAND",
  CARD_ADDED_TO_HAND_THIS: "CARD_ADDED_TO_HAND_THIS",
  CARD_ADDED_TO_HAND_OWNER: "CARD_ADDED_TO_HAND_OWNER",
  CARD_ADDED_TO_HAND_OPPONENT: "CARD_ADDED_TO_HAND_OPPONENT",

  // Play Event Triggers
  PLAY_EVENT: "PLAY_EVENT",
  PLAY_EVENT_THIS: "PLAY_EVENT_THIS",
  PLAY_EVENT_OWNER: "PLAY_EVENT_OWNER",
  PLAY_EVENT_OPPONENT: "PLAY_EVENT_OPPONENT",

  // Turn-based Triggers
  START_TURN: "START_TURN",
  START_TURN_OWNER: "START_TURN_OWNER",
  START_TURN_OPPONENT: "START_TURN_OPPONENT",
  END_TURN_PHASE: "END_TURN_PHASE",
  END_TURN_OWNER: "END_TURN_OWNER",
  END_TURN_OPPONENT: "END_TURN_OPPONENT",

  // Durability Triggers
  WEALTH_DURABILITY_ZERO: "WEALTH_DURABILITY_ZERO",
  WEALTH_DURABILITY_ZERO_THIS: "WEALTH_DURABILITY_ZERO_THIS",
  WEALTH_DURABILITY_ZERO_OWNER: "WEALTH_DURABILITY_ZERO_OWNER",
  WEALTH_DURABILITY_ZERO_OPPONENT: "WEALTH_DURABILITY_ZERO_OPPONENT",
  DAMAGE_THIS: "DAMAGE_THIS",
  BOOST_THIS: "BOOST_THIS",

  // Player Action Triggers
  PLAYER_PLAY_CARD_ACTION: "PLAYER_PLAY_CARD_ACTION",
  PLAYER_PLAY_CARD_ACTION_OWNER: "PLAYER_PLAY_CARD_ACTION_OWNER",
  PLAYER_PLAY_CARD_ACTION_OPPONENT: "PLAYER_PLAY_CARD_ACTION_OPPONENT",

  // Parameter Modification Triggers (for reaction checks)
  MODIFY_CONSCIOUSNESS_INCREASE_RESERVE_OWNER: "MODIFY_CONSCIOUSNESS_INCREASE_RESERVE_OWNER",
  MODIFY_CONSCIOUSNESS_DECREASE_RESERVE_OWNER: "MODIFY_CONSCIOUSNESS_DECREASE_RESERVE_OWNER",
  MODIFY_CONSCIOUSNESS_INCREASE_RESERVE_OPPONENT: "MODIFY_CONSCIOUSNESS_INCREASE_RESERVE_OPPONENT",
  MODIFY_CONSCIOUSNESS_DECREASE_RESERVE_OPPONENT: "MODIFY_CONSCIOUSNESS_DECREASE_RESERVE_OPPONENT",
  MODIFY_SCALE_INCREASE_RESERVE_OWNER: "MODIFY_SCALE_INCREASE_RESERVE_OWNER",
  MODIFY_SCALE_DECREASE_RESERVE_OWNER: "MODIFY_SCALE_DECREASE_RESERVE_OWNER",
  MODIFY_SCALE_INCREASE_RESERVE_OPPONENT: "MODIFY_SCALE_INCREASE_RESERVE_OPPONENT",
  MODIFY_SCALE_DECREASE_RESERVE_OPPONENT: "MODIFY_SCALE_DECREASE_RESERVE_OPPONENT",
  MODIFY_CARD_DURABILITY_INCREASE_RESERVE_OWNER: "MODIFY_CARD_DURABILITY_INCREASE_RESERVE_OWNER",
  MODIFY_CARD_DURABILITY_DECREASE_RESERVE_OWNER: "MODIFY_CARD_DURABILITY_DECREASE_RESERVE_OWNER",
  MODIFY_CARD_DURABILITY_INCREASE_RESERVE_OPPONENT: "MODIFY_CARD_DURABILITY_INCREASE_RESERVE_OPPONENT",
  MODIFY_CARD_DURABILITY_DECREASE_RESERVE_OPPONENT: "MODIFY_CARD_DURABILITY_DECREASE_RESERVE_OPPONENT",

  // Process-related Triggers
  SUCCESS_PROCESS: "SUCCESS_PROCESS",
  FAILED_PROCESS: "FAILED_PROCESS",
};

export const EffectType = {
  PLAYER_ACTION: 'PLAYER_ACTION',
  PLAYER_PLAY_CARD_ACTION: 'PLAYER_PLAY_CARD_ACTION',
  // Reservations
  MODIFY_CONSCIOUSNESS_RESERVE: "MODIFY_CONSCIOUSNESS_RESERVE",
  MODIFY_SCALE_RESERVE: "MODIFY_SCALE_RESERVE",
  MODIFY_CARD_DURABILITY_RESERVE: "MODIFY_CARD_DURABILITY_RESERVE",

  // Core Modifications
  MODIFY_CONSCIOUSNESS: "MODIFY_CONSCIOUSNESS",
  
  // Game Progression Animations (演出専用)
  TURN_START: "TURN_START",
  TURN_END: "TURN_END", 
  GAME_RESULT: "GAME_RESULT",
  TURN_ORDER_DECISION: "TURN_ORDER_DECISION",
  MODIFY_SCALE: "MODIFY_SCALE",
  SET_CONSCIOUSNESS: "SET_CONSCIOUSNESS",
  SET_SCALE: "SET_SCALE",
  
  // Actual Change Results (for accurate logging)
  CONSCIOUSNESS_CHANGED: "CONSCIOUSNESS_CHANGED",
  SCALE_CHANGED: "SCALE_CHANGED",
  CARD_DURABILITY_CHANGED: "CARD_DURABILITY_CHANGED",
  MODIFY_FIELD_LIMIT: "MODIFY_FIELD_LIMIT",
  ADD_MODIFY_PARAMETER_CORRECTION: "ADD_MODIFY_PARAMETER_CORRECTION",

  // Card State
  MODIFY_CARD_DURABILITY: "MODIFY_CARD_DURABILITY",
  MODIFY_CARD_REQUIRED_SCALE: "MODIFY_CARD_REQUIRED_SCALE",
  SET_CARD_DURABILITY: "SET_CARD_DURABILITY",

  // Card Manipulations
  ADD_CARD_TO_GAME: "ADD_CARD_TO_GAME",
  MOVE_CARD: "MOVE_CARD",
  MOVE_CARD_AFTER_ANIMATION: "MOVE_CARD_AFTER_ANIMATION", // 演出完了後にカード移動
  TRIGGER_AFTER_ANIMATION: "TRIGGER_AFTER_ANIMATION", // 演出完了後にトリガー実行
  REMOVE_CARD_FROM_GAME: "REMOVE_CARD_FROM_GAME",
  REORDER_FIELD_CARDS: "REORDER_FIELD_CARDS", // 新しく追加するエフェクトタイプ

  // System Effects
  DRAW_CARD: "DRAW_CARD",
  SKIP_EFFECT: "SKIP_EFFECT",
  CHECK_GAME_OVER: "CHECK_GAME_OVER",
  CHECK_WEALTH_DURABILITY: "CHECK_WEALTH_DURABILITY",

  // Process Handlers (Complex Effects)
  PROCESS_CARD_OPERATION: "PROCESS_CARD_OPERATION",
  PROCESS_PLAYER_CHOICE_CARD_MODIFICATION: "PROCESS_PLAYER_CHOICE_CARD_MODIFICATION",
  PROCESS_DRAW_RANDOM_CARD_AND_MODIFY_REQUIRED_SCALE: "PROCESS_DRAW_RANDOM_CARD_AND_MODIFY_REQUIRED_SCALE",
  PROCESS_DISCARD_ALL_HAND_WEALTH_CARDS_AND_DRAW: "PROCESS_DISCARD_ALL_HAND_WEALTH_CARDS_AND_DRAW",
  PROCESS_MOVE_HAND_WEALTH_TO_DECK_AND_DRAW: "PROCESS_MOVE_HAND_WEALTH_TO_DECK_AND_DRAW",
  PROCESS_CHOOSE_AND_DISCARD_IDEOLOGY: "PROCESS_CHOOSE_AND_DISCARD_IDEOLOGY",
  PROCESS_CHOOSE_AND_MOVE_CARD_FROM_PILE: "PROCESS_CHOOSE_AND_MOVE_CARD_FROM_PILE",
  PROCESS_CHOOSE_AND_MODIFY_DURABILITY_TO_WEALTH: "PROCESS_CHOOSE_AND_MODIFY_DURABILITY_TO_WEALTH",
  PROCESS_MODIFY_DURABILITY_TO_RANDOM_WEALTH_COUNT: "PROCESS_MODIFY_DURABILITY_TO_RANDOM_WEALTH_COUNT",
  PROCESS_MONEY_DURABILITY_BASED_COUNT_MODIFY_CARD_DURABILITY: "PROCESS_MONEY_DURABILITY_BASED_COUNT_MODIFY_CARD_DURABILITY",
  PROCESS_CHOOSE_AND_BOUNCE_TO_WEALTH: "PROCESS_CHOOSE_AND_BOUNCE_TO_WEALTH",
  PROCESS_RETURN_LARGEST_REQUIRED_SCALE_CARD_TO_DECK: "PROCESS_RETURN_LARGEST_REQUIRED_SCALE_CARD_TO_DECK",
  PROCESS_DISCARD_ALL_IDEOLOGY_FROM_HAND_AND_DECK: "PROCESS_DISCARD_ALL_IDEOLOGY_FROM_HAND_AND_DECK",
  PROCESS_ADD_CARD_CONDITIONAL_ON_DECK_COUNT: "PROCESS_ADD_CARD_CONDITIONAL_ON_DECK_COUNT",
  PROCESS_ADD_CARD_CONDITIONAL: "PROCESS_ADD_CARD_CONDITIONAL",
  PROCESS_SET_ALL_SCALE_TO_ZERO_AND_REDUCE_CONSCIOUSNESS: "PROCESS_SET_ALL_SCALE_TO_ZERO_AND_REDUCE_CONSCIOUSNESS",
  PROCESS_ADD_CARDS_BASED_ON_DISCARDED_COUNT: "PROCESS_ADD_CARDS_BASED_ON_DISCARDED_COUNT",
  PROCESS_MONEY_CARD_PLACEMENT_EFFECT: "PROCESS_MONEY_CARD_PLACEMENT_EFFECT",
  PROCESS_MONEY_CARD_TURN_START_EFFECT: "PROCESS_MONEY_CARD_TURN_START_EFFECT",
  PROCESS_ADD_CHOICE_CARD_TO_HAND: "PROCESS_ADD_CHOICE_CARD_TO_HAND",
  PROCESS_DISCARD_ALL_HAND_IDEOLOGY_AND_ADD_MONEY: "PROCESS_DISCARD_ALL_HAND_IDEOLOGY_AND_ADD_MONEY",
  PROCESS_REDUCE_MONEY_DURABILITY_AND_GAIN_SCALE: "PROCESS_REDUCE_MONEY_DURABILITY_AND_GAIN_SCALE",
  PROCESS_MODIFY_MONEY_DURABILITY_RANDOM: "PROCESS_MODIFY_MONEY_DURABILITY_RANDOM",
  PROCESS_ADD_MONEY_TOKEN_BASED_ON_CARDS_PLAYED: "PROCESS_ADD_MONEY_TOKEN_BASED_ON_CARDS_PLAYED",
  PROCESS_COUNTER_ATTACK: "PROCESS_COUNTER_ATTACK",
  PROCESS_MOVE_RANDOM_CARD_BY_TYPE: "PROCESS_MOVE_RANDOM_CARD_BY_TYPE",
  PROCESS_DEAL_DAMAGE_TO_ALL_WEALTH: "PROCESS_DEAL_DAMAGE_TO_ALL_WEALTH",
  PROCESS_EXPOSE_CARD_BY_TYPE: "PROCESS_EXPOSE_CARD_BY_TYPE",
  PROCESS_YOCAN_DRAW: "PROCESS_YOCAN_DRAW",
  PROCESS_REDEVELOPMENT_PLAN: "PROCESS_REDEVELOPMENT_PLAN",

  // Internal effects for sequencing
  _PLACE_IDEOLOGY: "_PLACE_IDEOLOGY",
  PRESENT_EVENT_CARD: "PRESENT_EVENT_CARD", // Sentinel effect to present event card before effect resolution
  EVENT_CARD_PLAYED: "EVENT_CARD_PLAYED", // Animation-specific effect for event card play
  CARD_REVEALED: "CARD_REVEALED", // Animation-specific effect for revealing a card
};

// Game settings
export const INITIAL_HAND_SIZE = 3;
export const MAX_HAND_SIZE = 10;
export const BASE_CONSCIOUSNESS = 15;
export const FIRST_PLAYER_CONSCIOUSNESS_MODIFIER = -3;
export const MAX_CONSCIOUSNESS = 100;
export const MIN_CONSCIOUSNESS = 0;
export const INITIAL_SCALE = 5;
export const MAX_SCALE = 1000; 
export const MIN_SCALE = 0;
export const INITIAL_FIELD_LIMIT = 5;
export const MAX_FIELD_LIMIT = 10;
export const MIN_DECK_SIZE = 30;
export const MAX_DECK_SIZE = 100;

export const Location = {
    HAND: 'hand',
    FIELD: 'field',
    DECK: 'deck',
    DISCARD: 'discard',
    IDEOLOGY: 'ideology',
};

export const BGMCategory = {
    BASIC: 'BASIC',
    YONOTSUNE: 'YONOTSUNE',
    INGAME: 'INGAME',
    RESULT: 'RESULT',
};